import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* emailAccountActive(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_REQUEST
    });

    const res = yield call(Http.get, `emails/${action.payload?.emailAccount}`);
    yield put({
      type: Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_SUCCESS,
      payload: {
        emails: res.data.data
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchEmailAccountActive() {
  yield takeEvery(Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START, emailAccountActive);
}
